import { type ReactNode } from "react";

export function StepBody({
  title,
  lead,
  action,
  children,
}: {
  title: string;
  lead?: string;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-6">
      <div
        className="flex flex-col"
        style={{ gap: "var(--onb-step-head-gap, 8px)" }}
      >
        {action ? <div className="flex justify-end">{action}</div> : null}
        {/* The Figma guideline's step headings are 30px regular Aeonik, not the DS t-h2
            default; tokens, so /welcome, the drawer and the modal each match. */}
        <h1
          className="t-h2"
          style={{
            color: "var(--fg-1)",
            fontWeight: "var(--onb-step-title-weight, 400)",
            fontSize: "var(--onb-step-title-size, 30px)",
            lineHeight: "var(--onb-step-title-lh, 32px)",
          }}
        >
          {title}
        </h1>
        {lead ? <p className="t-body-sm">{lead}</p> : null}
      </div>
      {children}
    </div>
  );
}
